import React from 'react'
import ReactMarkdown from 'react-markdown'

import { colors, fonts, padding } from '../styles'
import styled from 'styled-components'

const Footer = (props) => {

    const {
        className,
        text,
        contact
    } = props;

    return (
        <footer className={className}>
            {text ? <div className="markdown"><ReactMarkdown source={text} /></div> : null}
            
            {contact.person ? <p>{contact.person}</p> : null}

            <div>
                {contact.address ? <span>{contact.address}</span> : null}
                {contact.citystatezip ? <span>{contact.citystatezip}</span> : null}
            </div>

            <div>
                {contact.phone ? <a href={`tel:${contact.phone}`}>{contact.phone}</a> : null}
                {contact.email ? <a href={`mailto:${contact.email}`}>{contact.email}</a> : null}
            </div>

        </footer>
    )
}

const StyledFooter = styled(Footer)`
    text-align: center;
    ${fonts.lato}
    color: ${colors.blue};
    padding: ${padding};

    p, span, a {
        font-weight: 700;
        font-size: 1rem;
        line-height: 1.4em;
        margin: 0;
    }

    span, a {
        &:after {
            content: '|';
            margin: 0 .5em;
        }

        &:last-child:after {
            display: none;
        }
    }

    a {
        color: currentColor;
        text-decoration: none;
    }
`

export default StyledFooter;